import {createSlice} from '@reduxjs/toolkit'

import fetchShippingProfiles from '../thunks/fetchShippingProfiles'
import fetchShippingProfileRequirement from '../thunks/fetchShippingProfileRequirement'
import validateDiscount from '../thunks/validateDiscount'
import fetchOrder from '../thunks/fetchOrder'

const initialState = {
  // Data fetched from and sent to server
  data: {
    shippingProfiles: [],
    shippingProfilesRequired: false
  },
  // Status and error
  status: '',
  error: null,
  // Local state
  shippingProfileDescription: ''
}

const shippingProfilesSlice = createSlice({
  name: 'shippingProfiles',
  initialState,
  reducers: {
    changeShippingProfilesStatus(state, action) {
      state.status = action.payload
    },
    setShippingProfileDescription(state, action) {
      state.shippingProfileDescription = action.payload
    }
  },
  extraReducers: {
    // Fetch shipping profile requirement
    [fetchShippingProfileRequirement.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchShippingProfileRequirement.fulfilled]: (state, action) => {
      state.status = action.payload.required ? 'required' : 'succeeded'
      state.data.shippingProfilesRequired = action.payload.required
    },
    [fetchShippingProfileRequirement.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    // Fetch shipping profiles when required
    [fetchShippingProfiles.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchShippingProfiles.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.data.shippingProfiles = action.payload.shipping_profiles
    },
    [fetchShippingProfiles.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    // Refetch shipping profiles when discounts change
    [validateDiscount.fetched]: (state) => {
      state.status = 'idle'
    },
    'discounts/removeDiscount': (state) => {
      state.status = 'idle'
    },
    // Fetch shipping profiles after order fetched
    [fetchOrder.fulfilled]: (state) => {
      state.status = 'idle'
    },
    // Fetch shipping profiles after filling out customer information from PayPal
    'customerInfo/paypalCustomerInfo': (state) => {
      state.status = 'idle'
    }
  }
})

export const {
    changeShippingProfilesStatus,
    setShippingProfileDescription
  } = shippingProfilesSlice.actions

export default shippingProfilesSlice.reducer


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/slices/shippingProfilesSlice.js